import { random, round2, round2Str ,getMinutesPassedToday,getMinutesPassedThisMonth} from "../helpers/helpers";

export const generateAhuLatestDataDemo = (meterId = 1400) => {
    const now = new Date();
    const formattedDate = `${now
        .getDate()
        .toString()
        .padStart(2, "0")}-${now.toLocaleString("default", {
        month: "short",
    })}-${now.getFullYear().toString().slice(-2)} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;

    // --------------------
    // TIME CALCULATIONS
    // --------------------
    const todayMinutes = getMinutesPassedToday();
    const monthMinutes = getMinutesPassedThisMonth();

    const dailyRunning = Math.round(todayMinutes * random(0.7, 0.9));
    const dailyIdle = todayMinutes - dailyRunning;

    const monthlyRunning = Math.round(monthMinutes * random(0.7, 0.9));
    const monthlyIdle = monthMinutes - monthlyRunning;

    // --------------------
    // Electrical
    // --------------------
    const voltR = random(238, 245);
    const voltY = random(238, 245);
    const voltB = random(238, 245);

    const currentR = random(0.05, 0.6);
    const currentY = random(0.05, 0.6);
    const currentB = random(0.05, 0.6);

    const avgVolt = round2((voltR + voltY + voltB) / 3);
    const avgCurrent = round2((currentR + currentY + currentB) / 3);
    const pf = random(0.85, 0.98);

    const returnTemp = random(24, 28);
    const supplyTemp = random(14, 18);

    return {
        meter_id: meterId,
        meter_name: "North-East 8th Floor AHU",

        // Time & Status
        dtime: formattedDate,
        status: "Online",
        fan_status: "On",
        rpm: Math.round(random(950, 1400)).toString(),

        // Electrical
        avg_volt: round2Str(avgVolt),
        avg_volt_ll: round2Str(random(415, 425)),
        avg_current: round2Str(avgCurrent),
        avg_pf: round2Str(pf),
        frequency: round2Str(random(49.9, 50.1)),

        current_r: round2Str(currentR),
        current_y: round2Str(currentY),
        current_b: round2Str(currentB),

        volt_r: round2Str(voltR),
        volt_y: round2Str(voltY),
        volt_b: round2Str(voltB),
        volt_ry: round2Str(random(418, 423)),
        volt_yb: round2Str(random(418, 423)),
        volt_rb: round2Str(random(418, 423)),

        total_active_power: round2Str(
            (avgVolt * avgCurrent * pf * 3) / 1000
        ),
        total_active_energy_imported: round2Str(random(82000, 90000)),

        // Air & Water
        return_air_temp: round2Str(returnTemp),
        return_air_humi: round2Str(random(45, 65)),
        supply_air_temp: round2Str(supplyTemp),
        supply_air_humi: round2Str(random(40, 60)),

        chilled_water_temp_in: round2Str(random(12, 14)),
        chilled_water_temp_out: round2Str(random(15, 18)),
        chilled_water_valve_percent: round2Str(random(15, 80)),
        chilled_water_valve_actual_value: round2Str(random(2000, 8000)),

        fresh_air_damper_percent: round2Str(random(15, 60)),
        fresh_air_damper_actual_value: round2Str(random(3000, 7000)),

        // IAQ
        co2: round2Str(random(500, 900)),
        avg_co2: round2Str(random(500, 900)),
        avg_co2_month: round2Str(random(800, 1200)),
        tvoc: round2Str(random(20, 150)),
        formaldehyde: round2Str(random(0.05, 0.25)),

        // ✅ REALISTIC TIME VALUES (minutes)
        total_running_time: dailyRunning,
        total_idle_time: dailyIdle,
        total_running_month_time: monthlyRunning,
        total_idle_month_time: monthlyIdle,

        daily_data_active_energy: round2Str(random(5, 25)),
        monthly_data_active_energy: round2Str(random(150, 350)),

        avg_return_air_temp: round2Str(returnTemp),
        avg_return_air_month_temp: round2Str(random(22, 26)),
    };
};
